export const createList = (min = 0, max = 100) => {
  return [...Array(max - min + 1)].map((_, i) => ({
    label: `${i + min}`,
    value: i + min,
  }));
};



// WEBPACK FOOTER //
// ./src/utils/common.js